import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const renderTooltip = (props, text) => <Tooltip {...props}>{text}</Tooltip>;

const TooltipCell = ({ children, text }) => {
  const childWithStyle = React.cloneElement(children, {
    style: { ...(children.props.style || {}), cursor: "pointer" },
  });

  return (
    <OverlayTrigger
      placement="top"
      overlay={(props) => renderTooltip(props, text)}
    >
      {childWithStyle}
    </OverlayTrigger>
  );
};

export default TooltipCell;
